<template>
  <div class="lieve-tandarts-page-container">
    <section class="lieve-tandarts-content container hidden-first">
      <div class="row">
        <div class="col-12">
          <div class="lieve-tandarts-header">
            <img src="../assets/images/lieve-tandarts-liggend.png" alt="Lieve Tandarts" class="lieve-tandarts-banner">
            <h1>Over De Lieve Tandarts</h1>
          </div>
          
          <div class="content-section">
            <p class="intro-text">
              In onderstaande video komt u meer te weten over het initiatief van De Lieve Tandarts.
            </p>
            
            <div class="video-container">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/h-CoWabRAAs" 
                title="De Lieve Tandarts" frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                allowfullscreen>
              </iframe>
            </div>
            
            <h2>Wat betekent dit keurmerk voor <span class="highlight">tandartspraktijk Tandzorg Gestel</span>?</h2>
            
            <p>
              Tijdens elk bezoek aan Tandzorg Gestel kunt u, naast goede zorg, extra aandacht verwachten. 
              Zo nodig plannen wij extra tijd in voor uw behandeling. Daarnaast zijn wij goed bereikbaar 
              voor zowel bestaande als nieuwe patiënten. Laat ons weten hoe we u het beste kunnen helpen. 
              Gedurende de behandeling geven we u uitleg over onze handelingen en we doen er alles aan 
              om u op uw gemak te stellen.
            </p>
            
            <div class="personal-commitment">
              <div class="personal-content">
                <div class="personal-text">
                  <h3>Persoonlijke Betrokkenheid</h3>
                  <p>
                    Als tandarts bij Tandzorg Gestel sta ik persoonlijk garant voor de kwaliteit en zorg 
                    die het keurmerk van De Lieve Tandarts vertegenwoordigt. Mijn doel is om elke patiënt 
                    met respect, aandacht en professionaliteit te behandelen.
                  </p>
                  <p>
                    De waarden van De Lieve Tandarts - zoals extra aandacht, goede bereikbaarheid en 
                    transparante communicatie - zijn volledig geïntegreerd in onze dagelijkse praktijkvoering.
                  </p>
                </div>
                <div class="personal-image">
                  <img src="../assets/images/milad.jpg" alt="Dr. Milad - Tandzorg Gestel" class="milad-image">
                </div>
              </div>
            </div>
            
            <h3>Feedback</h3>
            <p>
              Wij staan open voor feedback. Kunnen wij het nog beter doen? Of wilt u graag een compliment 
              achterlaten over iets wat extra goed verliep?
            </p>
            
            <p>
              Laat hier uw beoordeling achter: 
              <a href="https://delievetandarts.nl/beoordelingsformulier-tandartsen/" target="_blank" class="feedback-link">
                Beoordelingsformulier Tandartsen
              </a>
            </p>
            
            <p>
              Uw beoordeling komt op de website van De Lieve Tandarts. Zij zijn onafhankelijk en monitoren de 
              kwaliteit van alle tandartsen die het keurmerk De Lieve Tandarts dragen. Uw reactie en mening helpt 
              hen hierbij. Ook vanuit <span class="highlight">tandartspraktijk Tandzorg Gestel</span> zijn wij u 
              dankbaar voor uw beoordeling. Zo kunnen wij ons blijven verbeteren!
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "LieveTandarts",
  mounted() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if(entry.isIntersecting){
          entry.target.classList.add('show-first')
        } 
      })
    })

    const hiddenElements = document.querySelectorAll('.hidden-first')
    hiddenElements.forEach((el) => observer.observe(el))

    document.title = "De Lieve Tandarts | Tandzorg Gestel | Kwaliteit & Zorg"
    document.querySelector('meta[name="description"]').setAttribute("content", "Tandzorg Gestel is aangesloten bij De Lieve Tandarts. Ontdek wat dit keurmerk betekent voor uw tandheelkundige zorg en service.");
    this.$store.commit('updateActivePage', 'LieveTandarts')
  },
  methods: {
    scrollToRegisterSection() {
      this.$router.push({ path: '/' })
      this.$store.commit('updateScrollToRegister', true)
    },
    scrollToAppointmentSection() {
      this.$router.push({ path: '/' })
      this.$store.commit('updateScrollToAppointment', true)
    }
  }
}
</script>

<style scoped>
.hidden-first {
  opacity: 0;
  transform: translateY(30px);
  transition: all 1s ease;
}

.show-first {
  opacity: 1;
  transform: translateY(0);
}

.lieve-tandarts-page-container {
  padding: 2rem 0;
  min-height: 80vh;
}

.lieve-tandarts-header {
  text-align: center;
  margin-bottom: 3rem;
}

.lieve-tandarts-banner {
  max-width: 300px;
  height: auto;
  margin-bottom: 2rem;
}

.content-section {
  max-width: 800px;
  margin: 0 auto;
}

.intro-text {
  font-size: 1.6rem;
  text-align: center;
  margin-bottom: 2rem;
  color: #666;
}

.video-container {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  margin: 2rem 0;
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.highlight {
  color: var(--blue);
  font-weight: bold;
}

.contact-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin: 2rem 0;
  padding: 2rem;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.contact-method h4 {
  color: var(--blue);
  margin-bottom: 1rem;
}

.appointment-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin: 3rem 0;
  flex-wrap: wrap;
}

.appointment-cta {
  padding: 1rem 2rem;
  font-size: 1.6rem;
  border-radius: 5px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.feedback-link {
  color: var(--blue);
  text-decoration: underline;
}

.feedback-link:hover {
  color: #008c8c;
}

h1 {
  color: var(--black);
  font-size: 3.5rem;
  margin-bottom: 2rem;
}

h2 {
  color: var(--black);
  font-size: 2.5rem;
  margin: 3rem 0 1.5rem 0;
}

h3 {
  color: var(--blue);
  font-size: 2rem;
  margin: 2.5rem 0 1rem 0;
}

p {
  font-size: 1.6rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  color: #555;
}

.personal-commitment {
  margin-top: 4rem;
  padding: 3rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.personal-content {
  display: flex;
  align-items: center;
  gap: 3rem;
}

.personal-text {
  flex: 1;
}

.personal-image {
  flex: 0 0 300px;
}

.milad-image {
  width: 100%;
  height: 350px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.personal-text h3 {
  color: var(--blue);
  font-size: 2.2rem;
  margin-bottom: 1.5rem;
}

.personal-text p {
  font-size: 1.5rem;
  line-height: 1.7;
  color: #444;
}

@media (max-width: 768px) {
  .lieve-tandarts-banner {
    max-width: 250px;
  }
  
  .contact-options {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .personal-content {
    flex-direction: column;
    text-align: center;
  }
  
  .personal-image {
    flex: 0 0 auto;
    max-width: 250px;
    margin: 0 auto;
  }
  
  .milad-image {
    height: 280px;
  }
  
  .personal-commitment {
    padding: 2rem;
  }
  
  .appointment-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .appointment-cta {
    width: 100%;
    max-width: 300px;
    text-align: center;
  }
  
  h1 {
    font-size: 2.5rem;
  }
  
  h2 {
    font-size: 2rem;
  }
}
</style>
